// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"44d7cb52c0407e0dfd43","883":"4f07ea30f7413c95bbc1"}[chunkId] + ".js";
};